import type { ChainInfo } from "@keplr-wallet/types"

import { chainConfigMap } from "@common/target/constants"
import type { ChainName, ChainNetworkId } from "@common/target/types"
import type { TargetId } from "@common/target/types"
import { createChainInfo } from "@future/libs/chain/cosmosKit/utils"
import { domainConfig } from "@future/target/domain"

export const targetIdToChainNetworkId = (
  targetId: TargetId,
): ChainNetworkId => {
  switch (targetId) {
    case "rujidev":
      return "rujira-devnet"
    case "rujibeta":
      return "rujira-testnet"
    case "rujimainnet1":
      return "rujira-mainnet"
  }
}

export const chainNetworkIdToChainName = (
  network: ChainNetworkId,
): ChainName => {
  switch (network) {
    case "rujira-devnet":
    case "rujira-testnet":
    case "rujira-mainnet":
      return "rujira"
  }
}

export const chainIdToChainNetworkId = (chainId: string) => {
  const keys = Object.keys(chainConfigMap) as (keyof typeof chainConfigMap)[]

  for (const chainNetworkId of keys) {
    const chainConfig = chainConfigMap[chainNetworkId]

    if (chainConfig.chainId === chainId) {
      return chainNetworkId
    }
  }
}

const chainInfoMap = domainConfig.availableTargets.reduce(
  (map, targetInfo) => {
    const chainNetworkId = targetIdToChainNetworkId(targetInfo.id)
    const chainConfig = chainConfigMap[chainNetworkId]

    if (!map[chainConfig.chainId]) {
      map[chainConfig.chainId] = createChainInfo(chainConfig)
    }

    return map
  },
  {} as Record<string, ChainInfo>,
)

export const chainInfos = Object.values(chainInfoMap)
